import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { Box, Container, Divider, Row } from 'ravenjs';

import AppLogo from 'components/AppLogo';
import { DEFAULT_BRANDING } from 'constants/branding';

function InfoBox({ boxProps, children, dividerProps, logo, rowProps }) {
    return (
        <Container padding="50px 25px" style={{ maxWidth: 700 }}>
            <Box elevation={5} {...boxProps}>
                <Row direction="column" gutter={false} justify="center" {...rowProps}>
                    {logo && (
                        <>
                            <AppLogo src={DEFAULT_BRANDING.loginLogoUrl} alt="Mineral logo" />
                            <Divider margin="22px auto" width="75%" {...dividerProps} />
                        </>
                    )}
                    {children}
                </Row>
            </Box>
        </Container>
    );
}

InfoBox.propTypes = {
    boxProps: PropTypes.object,
    children: PropTypes.node,
    dividerProps: PropTypes.object,
    logo: PropTypes.bool,
    rowProps: PropTypes.object
};

InfoBox.defaultProps = {
    boxProps: null,
    children: null,
    dividerProps: null,
    logo: true,
    rowProps: null
};

export default InfoBox;
